
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { configStore } from "@/store/store";
import { MediaInputValue, MediaOptionsType } from "@/types/media";
import { fetchMediaObject } from "@/lib/media/media";

@Component
export default class MediaUploadDialog extends Vue {
  @Prop({ default: false })
  open!: boolean;

  @Prop({ default: false })
  multiple!: boolean;

  @Prop({
    default() {
      return [];
    }
  })
  acceptedFileTypes!: MediaOptionsType[];

  loading = false;

  get mediaChooserUrl() {
    if (configStore.documentSpecificNeededUrls) {
      let url = configStore.documentSpecificNeededUrls.mediaChooserUrl;

      if (this.multiple) {
        url += `&multiple=true`;
      }

      if (this.acceptedFileTypes.length) {
        const types = this.acceptedFileTypes.join(",");
        url += `&types=${types}`;
      }

      return url;
    }

    return "";
  }

  @Watch("open")
  onDialogUpdated() {
    if (this.open) {
      this.bindListeners();
      this.loading = true;
    } else {
      this.unbindListeners();
    }
  }

  beforeDestroy() {
    this.unbindListeners();
  }

  bindListeners() {
    document.addEventListener(
      "breakdanceMediaChooserReady",
      this.onDialogReady
    );
    // @ts-ignore
    document.addEventListener(
      "breakdanceMediaChooserSelect",
      this.onMediaSelected
    );
    document.addEventListener("breakdanceMediaChooserClose", this.closeDialog);
  }

  unbindListeners() {
    document.addEventListener(
      "breakdanceMediaChooserReady",
      this.onDialogReady
    );
    // @ts-ignore
    document.removeEventListener(
      "breakdanceMediaChooserSelect",
      this.onMediaSelected
    );
    document.removeEventListener(
      "breakdanceMediaChooserClose",
      this.closeDialog
    );
  }

  onDialogReady() {
    this.loading = false;
  }

  async onMediaSelected(event: CustomEvent) {
    if (event.detail) {
      const media = await fetchMediaObject(event.detail);

      if (!media) {
        console.error("Could not load media data.");
        return;
      }

      this.emit(media);
    }

    this.closeDialog();
  }

  emit(media: MediaInputValue) {
    let newValue = media;

    if (Array.isArray(media) && !this.multiple) {
      newValue = media[0];
    }

    this.$emit("input", newValue);
  }

  closeDialog() {
    this.$emit("close");
  }
}
